import { render } from "./VideoLessons.vue?vue&type=template&id=2ee6de0a&scoped=true"
import script from "./VideoLessons.vue?vue&type=script&lang=js"
export * from "./VideoLessons.vue?vue&type=script&lang=js"

import "./VideoLessons.vue?vue&type=style&index=0&id=2ee6de0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee6de0a"]])

export default __exports__